<mat-card class="card-style px-6 py-6 pt-0 h-full">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Tarifário</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <div class="mt-6">
    <div class="flex justify-between mb-5">
      <button
        mat-flat-button
        class="btn-tg-white w-1/5"
        (click)="removeSelection()"
      >
        Remover
      </button>
      <button
        mat-flat-button
        class="btn-tg w-1/5"
        [disabled]="!checkForm()"
        (click)="confirmSelection()"
      >
        Confirmar
      </button>
    </div>
    <div>
      <mat-tab-group animationDuration="400ms">
        <mat-tab label="tg.mob">
          @if (!loadingTgmob) {
            <div>
              <table-list-tariff-select
                [dataSource]="itemsListTgmob"
                [columns]="columns"
                [multiSelect]="multiSelect"
                [selected]="selected"
                [listSelected]="listSelected"
                (selectItem)="selectItem($event)"
              />
            </div>
            <div>
              @if (itemsListTgmob.length > 0) {
                <pagination
                  [currentPage]="pageTgmob"
                  [pageSize]="rowsTgmob"
                  [totalRecords]="numberRowsTgmob"
                  (pageChanged)="pageChanged($event, 'tgmob')"
                />
              }
            </div>
          } @else {
            <div>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
          }
        </mat-tab>
        <mat-tab label="Cliente" [disabled]="this.idClient < 0">
          @if (!loadingClient) {
            <div>
              <table-list-tariff-select
                [dataSource]="itemsListClient"
                [columns]="columns"
                [multiSelect]="multiSelect"
                [selected]="selected"
                [listSelected]="listSelected"
                (selectItem)="selectItem($event)"
              />
            </div>
            <div>
              @if (itemsListClient.length > 0) {
                <pagination
                  [currentPage]="pageClient"
                  [pageSize]="rowsClient"
                  [totalRecords]="numberRowsClient"
                  (pageChanged)="pageChanged($event, 'client')"
                />
              }
            </div>
          } @else {
            <div>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
          }
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</mat-card>
